import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { getTotalCreatedByUser } from '../../services/ticketService';
import TotalByCreatedUser from '../../components/dashboards/TotalByCreatedUser';
import DashboardDemandTypeFilter from '../../components/dashboards/DashboardDemandTypeFilter';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
  background-color: var(--color-bg-secondary);
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const PageTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 650;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--color-text-primary);
`;

const TotalByCreatedUserPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [filterDemandType, setFilterDemandType] = useState([]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await getTotalCreatedByUser({ demandType: filterDemandType });
      setData(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error('Error fetching total created by user:', err);
      setData([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [filterDemandType]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <PageContainer>
      <PageTitle>Dashboards • Criadores</PageTitle>
      <DashboardDemandTypeFilter
        selectedValues={filterDemandType}
        onValuesChange={setFilterDemandType}
        disabled={loading}
        fieldId="dashboard-created-demand-type"
      />
      <TotalByCreatedUser
        data={data}
        loading={loading}
        error={error}
        onRetry={fetchData}
        demandTypeFilter={filterDemandType}
      />
    </PageContainer>
  );
};

export default TotalByCreatedUserPage;

